import * as subscriptions from '@wix/auto_sdk_subscription_subscriptions';

export { subscriptions };
